import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Link } from 'react-router-dom';
import Button from '../Button';
import ChartCard from './ChartCard';

const ChartCardDemo = () => {
  return (
    <>
      <h4>Card with Chart</h4>
      <ChartCard
        title="Retirement Confidence"
        text={
          <p className="text-center text-lg-start  text-sub1 text-light-grey-normal fw-light lh-xs">
            Saving 8% will raise your Retirement Confidence level to 75%. Use
            the{' '}
            <Link
              to={'/retirement-planning'}
              className={'fw-bold text-light-grey-normal text-decoration-none'}
            >
              Retirement Planning
            </Link>{' '}
            tool to further customize your strategy.
          </p>
        }
        button={
          <Button
            className="col-12 col-lg-7"
            variant="primary"
            rightIcon={light('person-cane')}
            size="sm"
          >
            Retirement Planning
          </Button>
        }
      ></ChartCard>
    </>
  );
};

export default ChartCardDemo;
